import React, { useState, useEffect,useContext, useMemo,useRef  } from "react";

const PriceOfferCell = ({
   price,                 // number | string (e.g. 110 or "110")
   onSubmit,              // (newPriceNumber) => void | Promise<void>
   onCancel,              // optional callback when user cancels
   t = (s) => s,          // i18n function
 }) => {

   const [isEditing, setIsEditing] = useState(false);
   const [value, setValue] = useState(price ?? 0);
   const [dirty, setDirty] = useState(false);
   const inputRef = useRef(null);
 
   useEffect(() => { setValue(price ?? 0); setDirty(false); }, [price]);
   useEffect(() => { if (isEditing) inputRef.current?.focus(); }, [isEditing]);
 
   const openEdit = () => setIsEditing(true);
 
   const closeEdit = () => {
     setIsEditing(false);
     setValue(price ?? 0);
     setDirty(false);
     onCancel?.();
   };
 
const handleChange = (e) => {
  const raw = e.target.value
    .replace(/[^\d.]/g, "")   // remove everything except digits and dot
    .replace(/(\..*)\./g, "$1"); // keep only first dot
  setValue(raw);
  setDirty(String(raw) !== String(price ?? 0));
};
 
   const canSave = dirty && Number(value) > 0;
 
   const handleSave = async () => {
     if (!canSave) return;
     await onSubmit?.(Number(value));
     setDirty(false);
     setIsEditing(false);
   };
 
   const handleKey = (e) => {
     if (e.key === "Enter") { e.preventDefault(); handleSave(); }
     if (e.key === "Escape") { e.preventDefault(); closeEdit(); }
   };
 
   return (
     <div className="offer-cell">
       {!isEditing ? (
         <div className="offer-view">
           <button
             type="button"
             className="offer-button"
             onClick={openEdit}
             aria-label={t("Offer")}
           >
             {t("Offer")}
           </button>
 
           <span className="price-chip" aria-label={"Current price"}>
             {Number(price) || 0}<span className="currency"> $</span>
           </span>
         </div>
       ) : (
         <div className="offer-edit">
           <div className="flex-h" data-suffix="$">
               <button
             type="button"
             className="icon-btn cancel"
             aria-label={t("Cancel")}
             onClick={closeEdit}
           >
             {/* X icon */}
             <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
               <path fill="#0071E7" d="M11.41 10l4.3-4.29a1 1 0 10-1.42-1.42L10 8.59 5.71 4.29a1 1 0 10-1.42 1.42L8.59 10l-4.3 4.29a1 1 0 101.42 1.42L10 11.41l4.29 4.3a1 1 0 001.42-1.42z"/>
             </svg>
           </button>
             <input
               ref={inputRef}
               type="text"
               inputMode="numeric"
               pattern="\d*"
               value={value}
               onChange={handleChange}
               onKeyDown={handleKey}
               className="offer-input noMargin"
               style={{marginTop:'0px'}}
               aria-label={"Enter your offer"}
             />
             
           {canSave && (
  <button
   type="button"
   className="icon-btn save"
   aria-label={"Save offer"}
   onClick={handleSave}
   disabled={!canSave}
 >
   <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
     <path fill="currentColor" d="M9 16.2l-3.5-3.5a1 1 0 10-1.4 1.4l4.2 4.2a1 1 0 001.4 0l10-10a1 1 0 10-1.4-1.4L9 16.2z"/>
   </svg>
 </button>
           )}
           </div>
 
         
 
         </div>
       )}
     </div>
   );
 }


export default PriceOfferCell


